const emailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
const phoneRegex = /^\+\d{0,4}\s[\d()\-\s]+$/
const websiteRegex = /^(https?:\/\/)?(www\.)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)|(https?:\/\/)?(www\.)?(?!ww)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/
const dateRegex = /^(0[1-9]|1[1-9]|2[1-9]|3[01])\.(0[1-9]|1[012])\.(20)\d\d$/

export { emailRegex, phoneRegex, websiteRegex, dateRegex }
